import axios from 'axios';
import jsSHA from "jssha";
import connConfig from './connConfig';

/*const defaultUser = {
  email: 'no@no.com',
  name: 'Usuario Desconocido',
  username: 'userDefault',
  accessToken: "eyJhbGciOiJIUzIO5dUNfrlChOKDJ5U",
  expiryDate: "2000-01-01T01:01:00.000Z",
  sessionId: 8856,
  avatarImgPath: 'webapp/default-user-online.png',
  permissions: [
    { code: 1, name: "Global Access", value: 1},
    { code: 20, name: "Proveedores", value: 7},
    { code: 30, name: "Mezclas", value: 7}
  ],
  sites: [
    { id: 20, name: "Instalacion 2 (test B)" },
    { id: 21, name: "Instalacion 1 (parque A)" }
  ]
};*/


export default {
  //_user: null,
  loggedIn() {
    let userInfo = localStorage.getItem('userInfo');
    let userData = JSON.parse(userInfo)

    if (userInfo){
      let expiryDate = userData.expiryDate ? userData.expiryDate: new Date().getTime()/1000 ;
      if (expiryDate<new Date().getTime()/1000){
        console.log('App session expired', userData.expiryDate)
        userInfo = null;
      }
    }
    return !!userInfo;
  },

  async logIn(userData) {
    try {
      //protect user password locally
      const shaObj = await new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
      shaObj.update(userData.password);
      userData.password = shaObj.getHash("HEX")
      let userInfo = await axios.post(`auth/logIn`, userData, connConfig.connData() );
      localStorage.setItem('userInfo', JSON.stringify(userInfo.data));
      
      return {
        isOk: true,
        data: userInfo.data
      };
    }
    catch (e) {
      userData.password = null;
      if (e.response){
        let res=e.response.data||{};
        e.message= res.message||"Authentication failed, server malfunction?"
        e.message_es= res.message_es||"ha ocurrido un error al autenticar el usuario"
      } else{
        e.message = "Network or server offline"
        e.message_es = "error de comunicación, red o servidor fuera de linea"
      }
      e.isOk= false;
      throw e
    }
  },

  async keepAlive(userData){
    try {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let kaResponse = await axios.post(`auth/keepalive`, userData, connConfig.connData() );
      userInfo.accessToken = kaResponse.data.accessToken? kaResponse.data.accessToken : userInfo.accessToken;
      userInfo.expiryDate = kaResponse.data.expiryDate? kaResponse.data.expiryDate : userInfo.expiryDate;
      userInfo.sessionId = kaResponse.data.sessionId? kaResponse.data.sessionId : userInfo.sessionId;

      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      return {
        isOk: true,
        data: kaResponse.data
      };
    }
    catch (e) {
      let res=e.response.data;
      e.isOk= false;
      e.message= res.message||"Authentication failed (keepalive)"
      e.message_es= res.message_es||"ha ocurrido un error al auto-autenticar el usuario (keepalive)"
      throw e
    }
  },

  async logOut() {
    localStorage.removeItem('userInfo');
  },

  getUser() {
    try {
      // Get from localStorage
      let userInfo = localStorage.getItem('userInfo');
      if (userInfo){
        return {
          isOk: true,
          data: JSON.parse(userInfo)
        };
      }
      else{
        return { 
          isOk: false,
          message: "user offline",
          message_es: "usuario desconectado",
          data: {username: "no user", permissions:[], sites:[], avatarImgPath: 'webapp/default-user.png'} 
        };
      }      
    }
    catch {
      return { 
        isOk: false,
        message: "error identifying user",
        message_es: "error al identificar el usuario",
        data: {username: "no user", permissions:[], sites:[], avatarImgPath: 'webapp/default-user.png'}  
      };
    }
  },

  async getToken() {
    let user = JSON.parse(localStorage.getItem('userInfo'));
    if (user && user.accessToken) {
      return user.accessToken;
    } else {
      return null;
    }
  },

  async changeLocalPassword(loggedInPassword, username, assignedPassword) {
    try{
      const shaObjActPass = await new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
      const shaObjNewPass = await new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
      shaObjActPass.update(loggedInPassword);
      shaObjNewPass.update(assignedPassword);
      let response = await axios.patch(
        `auth/${username}/password`, 
        { 
          loggedInPassword: shaObjActPass.getHash("HEX"),
          assignedPassword: shaObjNewPass.getHash("HEX"),
        }, 
        connConfig.connData() 
      );
      return {
        isOk: true,
        message: response.data.message
      };
    }
    catch(e) {
      let res=e.response.data;
      return {
        isOk: false,
        message: res.message||"Failed to change password",
        message_es: "Ha ocurrido un error al cambiar la contraseña"
      }
    }
  },

  async createLocalUser(userData) {
    try {
      const shaObj = await new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
      //let {name, lastName, username, email, password } = userData;
      if (userData.password==userData.confirmedPassword){
        shaObj.update(userData.password);
        userData.password = shaObj.getHash("HEX")
      }else{
        delete userData.password;
      }
      delete userData.confirmedPassword;

      let res = await axios.post(`auth/createAccount`, userData, connConfig.connData() )
      
      return { 
        isOk: res.data.isOk||true,
        data: res.data
      };
    }
    catch(e) {
      let res=e.response.data;
      e.isOk= false;
      e.message= res.message||"Failed to create account",
      e.message_es= res.message_es||"Ha ocurrido un error al crear la cuenta"
      throw e  
    }
  },

  async deleteLocalUser(username) {
    try {
      let res = await axios.delete(`auth/${username}`, connConfig.connData() )
      
      return { 
        isOk: res.data.isOk||true,
        data: res.data
      };
    }
    catch(e) {
      let res=e.response.data;
      e.isOk= false;
      e.message= res.message||"Failed to create account",
      e.message_es= res.message_es||"Ha ocurrido un error al crear la cuenta"
      throw e  
    }
  }

};
